import { render, staticRenderFns } from "./product-fraction-wrapper.vue?vue&type=template&id=44362dca&scoped=true&"
import script from "./product-fraction-wrapper.vue?vue&type=script&lang=js&"
export * from "./product-fraction-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./product-fraction-wrapper.vue?vue&type=style&index=0&id=44362dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44362dca",
  null
  
)

export default component.exports